// Encrypted-only web routes. Must stay identical to the backend's WebEncryptionEndpointPolicy
// (docs/security/web-payload-encryption.md §3.1). Only these exact method + route pairs are
// encrypted; nothing is matched by prefix.

export const PUBLIC_KEY_ROUTE = "/public/web/encryption/public-key";

export const WEB_ROUTES = {
  sendOtp: "/public/web/user/send-otp",
  verifyOtp: "/public/web/user/verify-otp",
  verifyOtpWithFingerprint: "/public/web/user/print/verify-otp",
  login: "/public/web/user/login",
  loginWithPin: "/public/web/user/login/pin",
  signup: "/public/web/user/signup",
  signupVerify: "/public/web/user/signup/verify",
  signupVerifyWithFingerprint: "/public/web/user/print/signup/verify",
  refreshToken: "/public/web/user/refreshtoken",
  updateUser: "/User/web",
  updatePin: "/User/web/pin",
  forgotPin: "/User/web/forgotPassword",
  deleteUserVerify: "/User/web/Verify",
  addIdentifier: "/User/web/Identifiers",
  verifyIdentifier: "/User/web/Identifiers/Verify",
  deleteIdentifierVerify: "/User/web/Identifiers/Delete/Verify",
  consentStatusVerification: "/User/web/Consent/Update/Status/Verification",
  consentApprovalVerification: "/User/web/Consent/Approval/Verification",
  accountDiscovery: "/User/web/account/discovery",
  delinkVerification: "/User/web/account/delink/Verification",
  linkVerify: "/User/web/account/link/verify",
} as const;

export const WEB_ENCRYPTED_ROUTES: ReadonlyArray<readonly [string, string]> = [
  ["POST", WEB_ROUTES.sendOtp],
  ["POST", WEB_ROUTES.verifyOtp],
  ["POST", WEB_ROUTES.verifyOtpWithFingerprint],
  ["POST", WEB_ROUTES.login],
  ["POST", WEB_ROUTES.loginWithPin],
  ["POST", WEB_ROUTES.signup],
  ["POST", WEB_ROUTES.signupVerify],
  ["POST", WEB_ROUTES.signupVerifyWithFingerprint],
  ["POST", WEB_ROUTES.refreshToken],
  ["PUT", WEB_ROUTES.updateUser],
  ["PUT", WEB_ROUTES.updatePin],
  ["POST", WEB_ROUTES.forgotPin],
  ["DELETE", WEB_ROUTES.deleteUserVerify],
  ["POST", WEB_ROUTES.addIdentifier],
  ["POST", WEB_ROUTES.verifyIdentifier],
  ["POST", WEB_ROUTES.deleteIdentifierVerify],
  ["POST", WEB_ROUTES.consentStatusVerification],
  ["POST", WEB_ROUTES.consentApprovalVerification],
  ["POST", WEB_ROUTES.accountDiscovery],
  ["DELETE", WEB_ROUTES.delinkVerification],
  ["POST", WEB_ROUTES.linkVerify],
];

const allowlist = new Set(WEB_ENCRYPTED_ROUTES.map(([method, route]) => `${method} ${route}`));

export function isWebEncryptedRoute(method: string | undefined, url: string | undefined) {
  return !!method && !!url && allowlist.has(`${method.toUpperCase()} ${url}`);
}

/** Any /web/ route must be encrypted; one missing from the allowlist must not go out in plaintext. */
export function isWebRoute(url: string | undefined) {
  return !!url && (url === "/User/web" || url.startsWith("/User/web/") || url.startsWith("/public/web/"));
}
